module.exports = __webpack_public_path__ + "img/tapetype_g.93582774.png";